@if (showNavbar$()) {
  <div class="sol-app-container">
    <div class="sol-app-navbar">
      <sol-navbar />
    </div>
    <div class="sol-app-content" data-shortcut-layer="content">
      <sol-details>
        <sol-topbar [customBreadcrumbs]="leadingBreadcrumbs$() !== undefined">
          <ng-container slot="breadcrumbs">
            @if (leadingBreadcrumbs$(); as leading) {
              <ng-container *ngTemplateOutlet="leading" />
            }
          </ng-container>
        </sol-topbar>
        <sol-page>
          @if (activeRouteStatus$() === 'loading') {
            <sol-loader [loader]="SolLoader.ofBlocks(3).withMargin('0')" />
          } @else if (activeRouteStatus$() === 'forbidden') {
            <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
          } @else {
            <router-outlet />
          }
        </sol-page>
      </sol-details>
    </div>
  </div>
} @else {
  @if (activeRouteStatus$() === 'loading') {
    <sol-loader [loader]="SolLoader.ofBlocks(3)" />
  } @else if (activeRouteStatus$() === 'forbidden') {
    <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
  } @else {
    <router-outlet />
  }
}
<sol-overlays />
